/* eslint @typescript-eslint/no-var-requires: "off" */
'use client';

import { NextImageProps } from '@/components/atoms/image';

export type ImageCarouselProps = {
  image?: React.ReactNode;
  renderImage: (props: Partial<NextImageProps>) => React.ReactNode;
};

export function ImageCarousel({ image }: ImageCarouselProps) {
  return (
    <div className='flex items-center gap-6'>
      <div className='h-full max-w-[800px] lg:max-w-[900px]'> {image}</div>
    </div>
  );
}
